import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { AccessYetComponent } from './access-yet.component';
import { AccessYetRoutingModule } from './access-yet-routing.module';

@NgModule({
    imports: [
        CommonModule,
        AccessYetRoutingModule,
        ButtonModule
    ],
    declarations: [AccessYetComponent]
})
export class AccessYetModule {}
